import React from 'react';
import PropTypes from 'prop-types';
import Table from 'components/shared/table';
import { Spinner } from 'ui';
import NothingToGrade from '../NothingToGrade';

const GradingStationTableBody = props => {
  const { itemsToGrade = [], loading, gradableType, query, page } = props;
  if (loading) {
    return (
      <div className="d-f jc-c ai-c p-32 bg-white Table-body">
        <Spinner />
      </div>
    );
  }

  if (!itemsToGrade.length && !!query && page === 1) {
    return (
      <div className="Table-body p-16 bg-white">
        {t('grades.no_search_results')}
      </div>
    );
  }

  if (!itemsToGrade.length && (!query || page > 1)) {
    return <NothingToGrade />;
  }

  const formatText = item => {
    if (gradableType === 'user') {
      if (item.email) {
        return (
          <span>
            {item.name} - <span className="fs-i">{item.email}</span>
          </span>
        );
      }
      if (item.username) {
        return <span>{item.username}</span>;
      }
    }
    if (gradableType === 'lesson') return item.title;
    if (gradableType === 'group') return item.name;
    if (gradableType === 'long-waiting') {
      return (
        <span className="d-f w-fill">
          <span className="f-3 pr-8">{item.lessonTitle}</span>
          <span className="f-1 pr-8">
            {item.name ? item.name : item.username}
          </span>
          <span className="f-1">
            {t('grades.days_awaiting', {
              days: item.daysAwaitingGrade,
            })}
          </span>
        </span>
      );
    }
    return '';
  };

  const formatRow = item => {
    if (gradableType === 'lesson') {
      return (
        <Table.Row key={item.id}>
          <Table.BodyCell className="pl-24">
            <a href={`grades/${gradableType}/${item.id}`} className="w-fill">
              {formatText(item)}
            </a>
          </Table.BodyCell>
          <Table.BodyCell className="ta-c">
            {item.ungradedSubmissions}
          </Table.BodyCell>
          <Table.BodyCell className="ta-c">
            {item.longestDaysWaiting}
          </Table.BodyCell>
        </Table.Row>
      );
    }

    return (
      <Table.Row key={item.id}>
        <a href={`grades/${gradableType}/${item.id}`} className="w-fill">
          <Table.BodyCell className="pl-24">{formatText(item)}</Table.BodyCell>
        </a>
      </Table.Row>
    );
  };

  return (
    <div className="Table-body fz-16">
      {itemsToGrade.map((item, i) => formatRow(item))}
    </div>
  );
};

GradingStationTableBody.propTypes = {
  gradableType: PropTypes.string,
  params: PropTypes.shape({
    set: PropTypes.func,
  }),
  itemsToGrade: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      title: PropTypes.string,
      email: PropTypes.string,
      lessonTitle: PropTypes.string,
      username: PropTypes.string,
      ungradedSubmissions: PropTypes.number,
      longestDaysWaiting: PropTypes.number,
    }),
  ),
};

export default GradingStationTableBody;
